export default __webpack_public_path__ + "static/media/buster_klein_34.8cf5d121.jpg";